import { Suspense } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '@/lib/query-client'
import { AuthProvider } from '@/lib/auth/auth-context'
import { AdminAuthProvider } from '@/lib/admin/admin-context'
import { OrganizationProvider } from '@/lib/organization/organization-context'
import { ThemeProvider } from '@/components/theme-provider'
import { Toaster } from 'sonner'

export function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<div className="flex min-h-screen items-center justify-center"><p className="text-zinc-400">Loading...</p></div>}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme="light">
          <AdminAuthProvider>
            <AuthProvider>
              <OrganizationProvider>
                {children}
                <Toaster richColors />
              </OrganizationProvider>
            </AuthProvider>
          </AdminAuthProvider>
        </ThemeProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </Suspense>
  )
}
